module.exports = __webpack_public_path__ + "static/media/vip.154f0022.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/vip.png
// module id = 2029
// module chunks = 6